import React from 'react';

export const ChatSquareLike = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 37"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6305 32.5764L20.4435 31.2024C21.0735 30.1374 21.3885 29.6034 21.8955 29.3094C22.4025 29.0139 23.04 29.0034 24.315 28.9809C26.199 28.9494 27.3795 28.8339 28.3695 28.4229C29.2794 28.046 30.1063 27.4935 30.8027 26.7971C31.4991 26.1006 32.0516 25.2738 32.4285 24.3639C33 22.9869 33 21.2394 33 17.7444V16.2444C33 11.3349 33 8.87938 31.8945 7.07638C31.2764 6.06718 30.4283 5.21856 29.4195 4.59988C27.615 3.49438 25.1595 3.49438 20.25 3.49438H15.75C10.8405 3.49438 8.385 3.49438 6.582 4.59988C5.5728 5.21795 4.72417 6.06606 4.1055 7.07488C3 8.87938 3 11.3364 3 16.2444V17.7444C3 21.2394 3 22.9869 3.57 24.3639C3.94708 25.274 4.49976 26.1009 5.19647 26.7973C5.89318 27.4938 6.72027 28.0461 7.6305 28.4229C8.6205 28.8339 9.801 28.9479 11.685 28.9809C12.96 29.0034 13.5975 29.0139 14.1045 29.3094C14.61 29.6034 14.9265 30.1359 15.5565 31.2024L16.3695 32.5764C17.094 33.8004 18.9045 33.8004 19.6305 32.5764ZM11.25 15.0669C11.25 17.6949 14.4945 20.4894 16.485 21.9564C17.166 22.4589 17.5065 22.7094 18 22.7094C18.4935 22.7094 18.834 22.4589 19.515 21.9564C21.5055 20.4894 24.75 17.6964 24.75 15.0669C24.75 11.0514 21.0375 9.55138 18 12.6534C14.9625 9.55138 11.25 11.0514 11.25 15.0669Z"
      fill="currentColor"
    />
  </svg>
);
